import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: {
        data: Object,
        options: Object,
        totalLine: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    mounted() {
        let options = this.options;
        if (this.totalLine) {
            if (options.legend === undefined) {
                options.legend = {}
            } 
            options.legend.onClick = function(e, legendItem) {
                let index = legendItem.datasetIndex;
                let ci = this.chart;
                let meta = ci.getDatasetMeta(index);

                if (!legendItem.hidden && index != 0) {
                    ci.data.datasets[0].data.forEach((value, i) => {
                        ci.data.datasets[0].data[i] -= parseFloat(ci.data.datasets[index].data[i])
                    })
                }
                else if(index != 0){
                    ci.data.datasets[0].data.forEach((value, i) => {
                        ci.data.datasets[0].data[i] += parseFloat(ci.data.datasets[index].data[i])
                    })
                }

                meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
                ci.update();
            }
        }
        this.renderChart(this.data, options)
    },
    watch: {
        data: function(newVal, oldVal) { // watch it
            this.renderChart(newVal, this.options)
        }
    }
}